module.exports = __webpack_public_path__ + "media/icons/radio-8860db03.png";